import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 64px;
  height: 64px;
  color: currentColor;
`

// TODO Remove the onClick!
const Clock = ({ onClick, title = 'Clock', ...rest }: IconProps & { onClick: () => void }) => (
  <StyledIcon onClick={onClick} viewBox="0 0 64 64" title={title} {...rest}>
    <title>{title}</title>
    <g fill="currentColor">
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        x1="32"
        y1="2"
        x2="32"
        y2="12"
        strokeLinejoin="miter"
        strokeLinecap="butt"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        x1="62"
        y1="32"
        x2="52"
        y2="32"
        strokeLinejoin="miter"
        strokeLinecap="butt"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        x1="32"
        y1="62"
        x2="32"
        y2="52"
        strokeLinejoin="miter"
        strokeLinecap="butt"
      />
      <line
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="10"
        x1="2"
        y1="32"
        x2="12"
        y2="32"
        strokeLinejoin="miter"
        strokeLinecap="butt"
      />
      <circle
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeMiterlimit="10"
        cx="32"
        cy="32"
        r="30"
        strokeLinejoin="miter"
      />
      <polyline
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeMiterlimit="10"
        points=" 20,16 32,32 44,32 "
        strokeLinejoin="miter"
      />
    </g>
  </StyledIcon>
)

Clock.displayName = 'Clock'
Clock.needsWork = true
export default Clock
